import React, { useState } from 'react';
import {
  Box,
  Button,
  Stack,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Checkbox,
  FormControlLabel
} from '@mui/material';
import Navigation from './Navigation';
import RegisterStat from './RegisterStat';

const fieldTypes = ['string', 'date', 'decimal', 'integer'];

const DefineFieldsPage = ({ data, update, onNext, onBack, onGoTo }) => {
  const [fields, setFields] = useState(data.template || []);

  const handleFieldChange = (index, key, value) => {
    const updated = [...fields];
    updated[index][key] = value;

    // Reset sum checkbox when type changes
    if (key === 'type' && value !== 'decimal' && value !== 'integer') {
      updated[index].sum = false;
    }

    setFields(updated);
  };

  const addField = () => {
    setFields([...fields, { label: '', type: 'string', sum: false }]);
  };

  const removeField = (index) => {
    setFields(fields.filter((_, i) => i !== index));
  };

  const handleNext = () => {
    update({ template: fields });
    onNext();
  };

  return (
    <Box>
      <RegisterStat
        endpoint="https://stats.soliman.nl/register"
        site="binder.soliman.nl"
        app="Binder"
        module="DefineFields"
      />
      <Navigation
        currentKey="fields"
        onGoTo={onGoTo}
      />

      <Stack spacing={3} mt={2}>
        {fields.map((field, index) => (
          <Box key={index} borderBottom="1px solid #ccc" pb={2}>
            <TextField
              label="Field Label"
              fullWidth
              value={field.label}
              onChange={(e) => handleFieldChange(index, 'label', e.target.value)}
              sx={{ mb: 2 }}
            />

            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel>Field Type</InputLabel>
              <Select
                value={field.type}
                label="Field Type"
                onChange={(e) => handleFieldChange(index, 'type', e.target.value)}
              >
                {fieldTypes.map((type) => (
                  <MenuItem key={type} value={type}>{type}</MenuItem>
                ))}
              </Select>
            </FormControl>

            {(field.type === 'decimal' || field.type === 'integer') && (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={field.sum || false}
                    onChange={(e) => handleFieldChange(index, 'sum', e.target.checked)}
                  />
                }
                label="Include in Total"
              />
            )}

            {field.type === 'date' && (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={field.useToday || false}
                    onChange={(e) => handleFieldChange(index, 'useToday', e.target.checked)}
                  />
                }
                label="Use today’s date as default"
              />
            )}

            <Button variant="text" color="error" onClick={() => removeField(index)}>
              Remove Field
            </Button>
          </Box>
        ))}

        <Button variant="outlined" onClick={addField}>
          Add Field
        </Button>
      </Stack>

      <Stack direction="row" spacing={2} mt={4}>
        <Button variant="outlined" onClick={onBack}>Back</Button>
        <Button variant="contained" onClick={handleNext}>Next step</Button>
      </Stack>
    </Box>
  );
};

export default DefineFieldsPage;
